import { NotificationRingingIcon } from "vega-icons";

import { useUserProfile } from "@vega-api/extended/auth/hooks";
import { NotificationPreferenceType } from "@vega-api/generated/types/notificationPreferenceType";
import {
  useGetUserNotificationPreferences,
  useUpdateUserNotificationPreference,
} from "@vega-api/generated/user-notifications-v1/user-notifications-v1";
import { SectionHeader } from "@vega-core/components/Layout/SectionHeader";
import { Notice } from "@vega-core/components/Notice/Notice";
import {
  type NotificationLockConfig,
  NotificationPreferences,
} from "@vega-core/components/NotificationPreferences/NotificationPreferences";
import { m } from "@vega-core/paraglide/messages";

export const LPSettingsPreferences = () => {
  const { data: profile } = useUserProfile();
  const {
    data: preferences,
    isLoading,
    refetch,
  } = useGetUserNotificationPreferences({
    query: {
      select: ({ data }) => data,
    },
  });

  const { mutate, isPending: isUpdating } = useUpdateUserNotificationPreference(
    {
      mutation: {
        onSuccess: () => refetch(),
      },
    },
  );

  const handlePreferenceChange = async (id: string, enabled: boolean) => {
    mutate({
      data: { id, enabled },
    });
  };

  const lockConfig: NotificationLockConfig[] = [
    {
      type: NotificationPreferenceType.CAPITAL_ACTIVITY,
      message: m.settings_capitalActivity_tooltip(),
    },
  ];

  if (!profile) {
    return null;
  }

  return (
    <div className="flex flex-col divide-border/primary">
      <SectionHeader
        icon={<NotificationRingingIcon />}
        showIconBackground={false}
        title={m.settings_notifications()}
      />
      <div className="flex flex-col items-start pl-0 md:pl-13 pt-4">
        <Notice content={m.settings_someNotificationControl()} />

        <NotificationPreferences
          isLoading={isLoading}
          isUpdating={isUpdating}
          lockConfig={lockConfig}
          onPreferenceChange={handlePreferenceChange}
          preferences={preferences}
        />
      </div>
    </div>
  );
};
